export default {"src":"/_next/static/media/Grow Token.f5ffd105.svg","height":48,"width":48};